import { Button, Form, Row, Col, Modal } from "antd";
import styled from "styled-components";
import useModal from "../../../hooks/useModalGestaoJustificativa";
import { ModalContainer, Title, SelectAntd, Textarea, ButtonStyled } from "../styles";
import { FaInfoCircle, FaSave } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { useTalhaoJustificativaUpdate } from "../../../hooks/useTalhaoJustificativa";
import { showError, showSuccess } from "infra/helpers/alerta";
import { TalhaoJustificados } from "../../../interfaces/Talhao";

interface ModalEditarJustificativaProps {
  refetch: () => void;
  lista: TalhaoJustificados[] | undefined,
}

const { Item, useForm } = Form;

function ModalEditarJustificativa({ lista, refetch }: ModalEditarJustificativaProps) {
  const [form] = useForm();
  const {
    id,
    ids,
    isOpenEdit,
    setIsOpenEdit,
    setId,
    setIds,
    talhaoJustificado,
    setTalhaoJustificado
  } = useModal();

  const {  mutateAsync: updateTalhaoJustificativa } = useTalhaoJustificativaUpdate();

  const tipoJustificativa = [
    { label: 'Selecione o tipo', value: '' },
    { label: 'Climático', value: 0 },
    { label: 'Decisão Agronômica', value: 1 },
    { label: 'Problema Operacional', value: 2 },
  ]

  function closedModal() {
    setIsOpenEdit(false);
    setId('');
    setIds(new Set());
    setTalhaoJustificado(null);
    form.resetFields();
  }

 async function onFinish() {
    try {
      let tipoParecer = "0";
      if (id) {
        tipoParecer = talhaoJustificado?.justificativaAtrasoAceiteGerenteUnidadeUsuario ? "2" : "1";
      } else {
        const list = lista?.some(p => p.justificativaAtrasoAceiteGerenteUnidadeUsuario)
        tipoParecer = list ? "2" : "1";
      }
      const idsArr = id ? [id] : Array.from(ids);
      const payload = {
        ...form.getFieldsValue(),
        tipoParecer,
        planoOperacionalOperacaoTalhaoIds: idsArr,
      };

      const res = await updateTalhaoJustificativa({body: payload});

      if (res.status === 204) {
        showSuccess("Justificativa editada com sucesso!");
        closedModal();
        refetch();
        return;
      }
      showError('Erro ao editar justificativa');
    } catch (error) {
      showError('Erro ao editar justificativa');
    }
  }

  return (
    <CustomModal
      title={<Flex><MdEdit size={18} /> Editar Justificativa</Flex>}
      visible={isOpenEdit}
      onCancel={closedModal}
      width={"50%"}
      maskClosable={false}
      centered
      getContainer={document.body}
      className="teste"
      footer={
        <>
          <Button
            size="large"
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Fechar</Button>
          <ButtonStyled
            size="large"
            type="primary"
            // loading={loadingCreate || loadingUpdate}
            onClick={() => form.submit()}
            icon={<FaSave />}
          >  Salvar Justificativa</ButtonStyled>
        </>
      }
    >
      <ModalContainer>  
          <Title>
            <FaInfoCircle size={18} /> Dados Gerais
          </Title>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Item 
                    label="Tipo de Justificativa"
                    name="motivo"
                    rules={[{ required: true, message: "Campo Tipo de Justificativa é obrigatório" }]}
                    >
                    <SelectAntd
                        defaultValue="Selecione o tipo"              
                        options={tipoJustificativa?.map((item: any) => ({
                          label: item.label,
                          value: item.value,
                        }))}
                      />
                  </Item>
                </Col>

              </Row>
              <Row>
                <Col span={24}>
                  <Item 
                    label="Descrição da Justificativa"
                    name="observacao"
                    rules={[{ required: true, message: "Campo Descrição da Justificativa é obrigatório" }]}
                    >
                    <Textarea />

                  </Item>
                </Col>
              </Row>
          </Form>
      </ModalContainer>
    </CustomModal>
  );
}

const CustomModal = styled(Modal)`
  position: relative;
  max-height: 65vh;

  .ant-modal-content {
    border-radius: 10px;
    height: 100%;
    
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
  }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;

    height: calc(65vh - 122px);
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    overflow: hidden;
  }

  .ant-modal-footer {
    height: 61px;
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default ModalEditarJustificativa;